export const badgeVariant = employee => {
  switch (convertStatus(employee)) {
    case 'NOT ENROLLED':
    case 'DISABLED':
    case 'LEAVER':
      return 'secondary';
    case 'OPTED OUT':
    case 'PAUSED':
      return 'secondary-light';
    case 'OPT OUT PENDING':
      return 'tertiary-light';
    default:
      return 'primary-light';
  }
};

export const convertStatus = employee => {
  if (employee.current_state === 'DISABLED' && employee.properties?.optout_initiated_at) {
    if (!employee.properties?.optout_completed_at) {
      return 'OPT OUT PENDING';
    } else if (employee.terminated_at) {
      return 'LEAVER';
    } else {
      return 'OPTED OUT';
    }
  }

  if (employee.current_state === 'DISABLED' && employee.terminated_at) {
    return 'LEAVER';
  }

  if (employee.properties?.paused && employee.current_state !== 'DISABLED') {
    return 'PAUSED';
  }

  const convertedStatuses = {
    // the employee has not yet signed up, nothing happening yet, NOT YET ACTIVE
    NEW: 'NOT ENROLLED',
    INSTALLED: 'NOT ENROLLED',
    // the employee uses the app, USING
    ACTIVE: 'ENROLLED',
    ENROLLED: 'ENROLLED',
    // the employee is in the process of activating and using the app, ONBOARDING
    ENROLLING: 'ENROLLING',
    PENDING: 'ENROLLING',
    // for some reason the employee is not using the app, DISABLED
    FURLOUGH: 'DISABLED',
    OPTOUT: 'OPTED OUT',
    OPTOUTPENDING: 'DISABLED',
    PAUSED: 'PAUSED',
    DISABLED: 'DISABLED',
  };

  return convertedStatuses[employee.current_state] || 'NO STATUS';
};

export const isEmployeeEnrolled = employee => {
  return employee.current_state === 'ACTIVE' || employee.current_state === 'ENROLLED';
};

export const isEmployeeDisabledOrOptedOut = employee => {
  return (
    employee.current_state === 'OPTOUT' ||
    employee.current_state === 'OPTOUTPENDING' ||
    employee.current_state === 'DISABLED'
  );
};
